<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Einstellungen</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>Kann zusätzlich beschreiben</col-label>
          <div class="col-4">
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.newDialogModNormalDialog"
                id="normalDialog"
              />
              <label
                class="form-check-label custom-control-label"
                for="normalDialog"
                >Normale Dialoge</label
              >
            </div>
          </div>
          <div class="col-4">
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.newDialogModAsaDialog"
                id="asaDialog"
              />
              <label
                class="form-check-label custom-control-label"
                for="asaDialog"
                >Asa Dialoge</label
              >
            </div>
          </div>
        </div>
        <div class="form-group row">
          <col-label>Anzahl der Nachrichten von Moderatoren</col-label>
          <div class="col-8">
            <input
              type="number"
              class="form-control"
              v-model="data.newDialogMessagesAmount"
            />
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
        <hr />

        <div class="form-group row">
          <col-label>Moderator</col-label>
          <div class="col-8">
            <moderator-select @input="selectModerator" />
          </div>
        </div>
        <div class="form-group">
          <button @click="addModerator()" class="btn btn-primary">
            Hinzufügen/Entfernen
          </button>
        </div>
      </div>

      <v-table
        url="/api/v1/moderator"
        :filter="[
          {
            name: 'where',
            attributes: { new_dialogs: 1 }
          }
        ]"
        :row-classes="{
          'table-warning': model => {
            return Boolean(model.user && model.user.disabled_at);
          },
          'table-danger': model => {
            return Boolean(model.deleted_at);
          }
        }"
        :counter="counter"
        :attributes="[
          {
            attribute: 'user.id',
            name: 'ID',
            sortable: false
          },
          {
            name: 'Moderator',
            type: 'UserNoEmailCell',
            attribute: 'user',
            sortable: false
          }
        ]"
      ></v-table>
    </div>
  </section>
</template>

<script>
import ModeratorSelect from "@/components/selector/DropdownModeratorSelector";
export default {
  components: {
    ModeratorSelect
  },
  created() {
    this.$store.dispatch("setting/all").then(() => {
      this.data.newDialogMessagesAmount = this.$store.getters["setting/key"](
        "newDialogMessagesAmount"
      );
      this.data.newDialogModNormalDialog = this.$store.getters["setting/key"](
        "newDialogModNormalDialog"
      );
      this.data.newDialogModAsaDialog = this.$store.getters["setting/key"](
        "newDialogModAsaDialog"
      );
    });
  },
  data() {
    return {
      data: {
        newDialogMessagesAmount: 3,
        newDialogModNormalDialog: false,
        newDialogModAsaDialog: false
      },
      moderator: 0,
      counter: 0
    };
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store
        .dispatch("setting/update", data)
        .then(() => {
          this.$notify({
            title: "Einstellungen gespeichert",
            type: "success"
          });
        })
        .catch(error => {
          this.$notify({
            title: error.response.data,
            type: "error"
          });
        });
    },
    selectModerator(moderatorId) {
      this.moderator = moderatorId;
    },
    addModerator() {
      this.$http
        .post(`/api/v1/moderator/${this.moderator}/toggle-new-dialog`)
        .then(() => {
          this.$notify({
            title: "Moderator gespeichert",
            type: "success"
          });
          this.counter++;
        })
        .catch(error => {
          this.$notify({
            title: error.response.data,
            type: "error"
          });
        });
    }
  }
};
</script>
